import { useContext } from "react"
import UserContext from "../context/User/UserContext"


export const useAuth = () =>{
    const context = useContext(UserContext)     // crea un contexto el cual contiene todo lo que se ha creado en UserState
    return { ...context}

}
